
export const AlertData = [

    // {
    //     "date": 1633330248000,
    //     "lat": 12.223344,
    //     "lng": 79.057403,
    //     "location": "Sri Dakshinamurthy Temple, NH 66 (Next to Ramanasramam), Tiruvannamalai, Tamil Nadu, India",
    //     "vehId": "TN03AC2122",
    //     "employeeID": "611f872e3402074c57abe7c4",
    //     "orgID": "60866279d774d4408635033b",
    //     "sosID": "614d706428f4a9b0117e9fff"
    // },
    {
        angle: '180',
        batteryDisconnect: '1',
        distance: 0,
        gpsDateTime: 1620758728000,
        internalBattery: '04.140', // 12.025566007839128, 79.15346168307198
        location: { lat: 12.025566007839128, lng: 79.15346168307198 },
        mainBattertPower: '13.864',
        nearLocationFull: '0.40 km from Dwarka, New Delhi, South West Delhi, Delhi, India',
        nearLocationShort: '0.40 km from Dwarka, New Delhi, South West Delhi, Delhi, India',
        notifications: [],
        powerOnReset: '0',
        powerSensor1: '1',
        powerSensor2: '0',
        rtcDateTime: false,
        serverDateTime: 1620758728000,
        speed: 27,
        switch: 'N',
        vehRegNo: 'Tn32AE2132',
        userID: 123,
        driverID:12334,
        vendorID:123411,
        time:'Yesterday 01:12 am'
    },
    {
        angle: '180',
        batteryDisconnect: '1',
        distance: 0,
        gpsDateTime: 1620758068000,
        internalBattery: '04.140', // 12.031861967333668, 79.1712286354877
        location: { lat: 12.031861967333668, lng: 79.1712286354877 },
        mainBattertPower: '13.864',
        nearLocationFull: '0.40 km from Dwarka, New Delhi, South West Delhi, Delhi, India',
        nearLocationShort: '0.40 km from Dwarka, New Delhi, South West Delhi, Delhi, India',
        notifications: [],
        powerOnReset: '0',
        powerSensor1: '1',
        powerSensor2: '0',
        rtcDateTime: false,
        serverDateTime: 1620758068000,
        speed: 27,
        switch: 'N',
        vehRegNo: 'Tn32EW2145',
        userID: 1234,
        driverID:12335,
        vendorID:123412,
      
    },
    {
        angle: '180',
        batteryDisconnect: '1',
        distance: 0,
        gpsDateTime: 1620759328000,
        internalBattery: '04.140', // 12.021116774252109, 79.17037032860772
        location: { lat: 12.021116774252109, lng: 79.17037032860772 },
        mainBattertPower: '13.864',
        nearLocationFull: '0.40 km from Dwarka, New Delhi, South West Delhi, Delhi, India',
        nearLocationShort: '0.40 km from Dwarka, New Delhi, South West Delhi, Delhi, India',
        notifications: [],
        powerOnReset: '0',
        powerSensor1: '1',
        powerSensor2: '0',
        rtcDateTime: false,
        serverDateTime: 1620759328000,
        speed: 27,
        switch: 'N',
        vehRegNo: 'Tn45NR4352',
        userID: 12345,
        driverID:12336,
        vendorID:123413,
      
    }
];

export const UserData = {
    "611f872e3402074c57abe7c4": {
        userID: 123,
        name: 'Raja',
        mobileNo: 9123456780,
        empid: 'abc123',
        address: 'no-21,cross road ,chennai',
        location: { lat: 12.025566007839128, lng: 79.15346168307198 },
        profilePhoto: 'man.png',
        time:'Yesterday'
    },
    "611226d307434a2d0f3a0bd0": {
        userID: 1234,
        name: 'mohan',
        mobileNo: 9785634120,
        empid: 'abc1234',
        address: 'no-21,cross road ,chennai',
        location: { lat: 12.031861967333668, lng: 79.1712286354877 },
        profilePhoto: 'profile.png',
        time:'02/07/2021'
    },
    12345: {
        userID: 12345,
        name: 'ragu',
        mobileNo: 9876543210,
        empid: 'abc12345',
        address: 'no-21,cross road ,chennai',
        location: { lat: 12.021116774252109, lng: 79.17037032860772 },
        profilePhoto: 'user4.jpeg',
        time:'12:44 am'
    }
};

export const vehicleData = {
    'TN32Ar9768': {
        chassisNo: 'asd234324dsfwr24',
        regiNo: 'TN32Ar9768',
        engineNo: 'ae2342332dsdfds',
        expiryDate: 1620518400000,
        imei: '898988737373722',
        make: 'Honda',
        model: '2021',
        orgID: '605471600e7dae2fdce593d8',
        purchasedDate: 1620000000000,
        rcExpiryDate: 1620777600000,
        rcNo: 'AEI234232ER',
        location: { lat: 12.027934288849709, lng: 79.14242556588502 },
    },
    'TN07CP8975': {
        chassisNo: 'asd234324dsfwr25',
        regiNo: 'TN07CP8975',
        engineNo: 'ae2342332dsdfds',
        expiryDate: 1620518400000,
        imei: '898988737373722',
        make: 'Honda',
        model: '2021',
        orgID: '605471600e7dae2fdce593d8',
        purchasedDate: 1620000000000,
        rcExpiryDate: 1620777600000,
        rcNo: 'AEI234232ER',
        location: { lat: 12.016433390162518, lng: 79.15289690978285 },
    },
    'Tn45NR4352': {
        chassisNo: 'asd234324dsfwr24',
        regiNo: 'Tn45NR4352',
        engineNo: 'ae2342332dsdfds',
        expiryDate: 1620518400000,
        imei: '898988737373722',
        make: 'Honda',
        model: '2021',
        orgID: '605471600e7dae2fdce593d8',
        purchasedDate: 1620000000000,
        rcExpiryDate: 1620777600000,
        rcNo: 'AEI234232ER',
        location: { lat: 12.023778911528428, lng: 79.15422728547506 },
    }
};

export const DriverData = {
    12334: {
        name:'Sathish',
        driverID:'12334',
        mobile: '9489989784',
        licence: 'TN4300000012344',
        licenceUrl: 'path',
    },
    12335: {
        name:'Karthick',
        driverID:'12335',
        mobile: '9989948785',
        licence: 'TN4300000034323',
        licenceUrl: 'path',
    },
    12336: {
        name:'kamal',
        driverID:'12336',
        mobile: '8923429489',
        licence: 'TN4300000083452',
        licenceUrl: 'path',
    }
}
export const VendorData = {
    123411: {
        name:'vendor-1',
        vendorID:'123411',
        mobile: '8757184938',
        VehicleCnt: 45,
        driverCnt: 34
    },
    123412: {
        name:'vendor-2',
        vendorID:'123412',
        mobile: '9875734312',
        VehicleCnt: 56,
        driverCnt: 14
    },
    123413: {
        name:'vendor-3',
        vendorID:'123413',
        mobile: '9182335912',
        VehicleCnt: 64,
        driverCnt: 34
    },
}


export const cabData = [
    {   "name":'Karthick',
        "mobileNo":9192341123,
        "orgID": "60866279d774d4408635033b",
        "vendorID": "60cae868ef11c5a004e910b6",
        "vehRegNo": "TN32Ar9768",
        "imei": "862549041909097",
        "make": "Shamshad",
        "model": "Hatchback",
        "chassisNo": "dsdfgk20902934-02",
        "engineNo": "klsjdfgi09234io-2",
        "purchasedDate": 1625077800000,
        "routePermitCost": "30000",
        "startDate": 1625769000000,
        "expiryDate": 1626892200000,
        "roadTaxStatus": true,
        "rcNo": "rac",
        "rcStartDate": null,
        "rcExpiryDate": 1627410600000,
        "vehicleInfo": "Shamshad info",
        "rcfile": "undefinedvehicles/60866279d774d4408635033b/60cae868ef11c5a004e910b6/91453f43e6b2946149a8a394b17335c2d4934e5cf61721e3f9b46f036f0f5de2",
        "capacity": "4",
        "vehicleType": "owned",
        "boxType": "group10",
        "location": {
            "lat": 9.638851,
            "lng": 78.84698,
            "name": "R.S.Mangalam, Tiruvadanai, Ramanathapuram, Tamil Nadu, India"
        },
        "createdBy": null,
        "status": 1,
        "createdAt": 1626762014783,
        "simNo": "5754180238316",
        "updatedAt": 1626872329724,
        "updatedBy": "rajae@groupten.com",
        "vehicleID": "60f66b1e26aa652f099fb283"
    },
    {
        "name":'Vinoth',
        "mobileNo":8123453123,
        "orgID": "60866279d774d4408635033b",
        "vendorID": "60cae868ef11c5a004e910b6",
        "vehRegNo": "TN58RT8674",
        "imei": "862549042141831",
        "make": "Shamshad",
        "model": "SUV",
        "chassisNo": "dsdfgk20902934-02",
        "engineNo": "klsjdfgi09234io-2",
        "purchasedDate": 1625077800000,
        "routePermitCost": "30000",
        "startDate": 1625769000000,
        "expiryDate": 1626892200000,
        "roadTaxStatus": true,
        "rcNo": "rac",
        "rcStartDate": null,
        "rcExpiryDate": 1627410600000,
        "vehicleInfo": "Shamshad info",
        "rcfile": "undefinedvehicles/60866279d774d4408635033b/60cae868ef11c5a004e910b6/c897ec993ac57d0ba041cc2c288fd9cce558be57e7b7068f4382b0961bb4dd35",
        "capacity": "4",
        "vehicleType": "owned",
        "boxType": "group10",
        "location": {
            "lat": 16.977389,
            "lng": 74.639604,
            "name": "Nagaon Kavathe, Tasgaon, Sangli, Maharashtra, India"
        },
        "createdBy": null,
        "status": 1,
        "createdAt": 1626762030668,
        "simNo": "5754180238128",
        "updatedAt": 1626872360384,
        "updatedBy": "rajae@groupten.com",
        "vehicleID": "60f66b2e26aa652f099fb284"
    },
    {   
        "name":'Sathish',
        "mobileNo":9182119823,
        "orgID": "60866279d774d4408635033b",
        "vendorID": "60cae868ef11c5a004e910b6",
        "vehRegNo": "TN09DR7652",
        "imei": "861359038031306",
        "make": "sathish",
        "model": "Bus",
        "chassisNo": "dsdfgk20902934-02",
        "engineNo": "klsjdfgi09234io-2",
        "purchasedDate": 1625077800000,
        "routePermitCost": "30000",
        "startDate": 1625769000000,
        "expiryDate": 1626892200000,
        "roadTaxStatus": true,
        "rcNo": "rac",
        "rcStartDate": null,
        "rcExpiryDate": 1627410600000,
        "vehicleInfo": "Shamshad info",
        "rcfile": "undefinedvehicles/60866279d774d4408635033b/60cae868ef11c5a004e910b6/7b3fa7c4131d03d5492010f8ffca34ad777cedd146abeb69540dbbb0dd5e13b4",
        "capacity": "4",
        "vehicleType": "owned",
        "boxType": "group10",
        "location": {
            "lat": 16.977389,
            "lng": 74.639604,
            "name": "Nagaon Kavathe, Tasgaon, Sangli, Maharashtra, India"
        },
        "createdBy": null,
        "status": 1,
        "createdAt": 1626762057713,
        "simNo": "5754180262196",
        "updatedAt": 1626872386031,
        "updatedBy": "rajae@groupten.com",
        "vehicleID": "60f66b4926aa652f099fb285"
    }
];